import { cn } from "@/utils/cn";

/** Toolbar row above the framed table (title + controls). */
export function getDataTableOrganismToolbarClassName(hasTitle: boolean): string {
  return cn(
    "my-4 flex flex-col gap-3 sm:flex-row sm:items-center",
    hasTitle ? "sm:justify-between" : "sm:justify-end"
  );
}

export const dataTableOrganismToolbarTitleClass =
  "flex min-w-0 flex-1 items-center gap-2";

export const dataTableOrganismToolbarControlsClass =
  "flex w-full shrink-0 items-stretch gap-2 sm:w-auto sm:items-center sm:justify-end sm:gap-3";

export const dataTableOrganismToolbarEndSlotClass =
  "flex items-center justify-end gap-2";

export const dataTableOrganismSelectCellWrapperClass =
  "flex w-full justify-center";

export const dataTableOrganismColumnMenuContentClass = "min-w-52";

export const dataTableOrganismColumnVisibilityTriggerClass =
  "border border-background-grey rounded-full";
